import { type SprintView } from '@apm/contracts';

/**
 * Sprint mà tab Công việc mở ra khi người dùng chưa chọn gì — APM-SPRINT-f.
 *
 * ## Vì sao cần nó, khi server đã tự lấy sprint đang chạy
 *
 * `BoardService` gọi `findActive()`, và đúng như tên: nó chỉ tìm sprint
 * `active`. Dự án vừa lập kế hoạch xong chưa bắt đầu sprint nào, dự án vừa đóng
 * sprint cuối cũng vậy — cả hai rơi vào cùng một chỗ: server trả `sprint: null`
 * và màn hình dừng lại ở câu "Chọn một sprint để xem công việc".
 *
 * Câu ấy đúng về mặt logic và sai về mặt dùng: người mở tab Công việc muốn thấy
 * công việc, và gần như luôn là công việc của **cùng một** sprint mà họ sẽ chọn
 * bằng tay ngay sau đó. Bắt họ chọn là bắt trả lời một câu hỏi chỉ có một đáp
 * án hợp lý.
 *
 * ## Không có sprint đang chạy thì lấy sprint **mới nhất**
 *
 * Quyết định của người dùng, 2026-09-28. Mới nhất theo `sequence`, không theo
 * ngày: `sequence` là thứ tự dự án tự đánh khi tạo sprint, nên nó đúng cả khi
 * ngày tháng bị sửa lui — mà sửa ngày một sprint chưa chạy là chuyện thường.
 * Và nó không phân biệt trạng thái: sprint mới nhất của một dự án vừa đóng hết
 * mọi sprint **là** cái vừa đóng, đúng bối cảnh người ta đang đứng.
 *
 * Trả `null` khi danh sách rỗng — dự án chưa có sprint nào thì không có gì để
 * mặc định, và chỗ gọi đã có nhánh riêng cho cảnh đó.
 */
export function defaultSprint(sprints: readonly SprintView[]): SprintView | null {
  const active = sprints.find((sprint) => sprint.status === 'active');
  if (active) return active;

  return sprints.reduce<SprintView | null>(
    (latest, sprint) => (latest === null || sprint.sequence > latest.sequence ? sprint : latest),
    null,
  );
}
